// MAENG: hide placeholder on focus, restore on blur if empty
(function () {
  const SEL = '.maeng-mm-search__input';
  const DEFAULT = 'Search';

  function onFocus(e){
    const el = e.target;
    if (!el || !el.matches || !el.matches(SEL)) return;

    // placeholder를 잠깐 제거 (클릭하면 Search 텍스트 사라짐)
    el.dataset.maengPh = el.getAttribute('placeholder') || DEFAULT;
    el.setAttribute('placeholder', '');
  }

  function onBlur(e){
    const el = e.target;
    if (!el || !el.matches || !el.matches(SEL)) return;

    // 입력이 없으면 placeholder 복구
    if ((el.value || '').trim() === '') {
      el.setAttribute('placeholder', el.dataset.maengPh || DEFAULT);
    }
  }

  document.addEventListener('focusin', onFocus, true);
  document.addEventListener('focusout', onBlur, true);
})();